export function getRootUrl() {
  return window.location.origin + window.location.pathname;
}
